
import { useIsMobile } from './use-mobile';

export function useSpotifyDeepLink() {
  const isMobile = useIsMobile();
  
  const openSpotifyLink = (spotifyUrl: string): void => {
    if (!spotifyUrl) return;
    
    // Extract the Spotify ID from the URL
    const spotifyId = spotifyUrl.split('/').pop() || '';
    
    if (isMobile) {
      // On mobile, we try to use deep linking first
      const spotifyAppUri = `spotify:track:${spotifyId}`;
      const webUrl = spotifyUrl;
      
      // Use a timestamp to detect if we've left the page
      const navigatedAt = Date.now();
      let hasRedirected = false;
      
      // Set a timer to check if opening the app failed
      const timeoutId = setTimeout(() => {
        // If we're still here after the timeout, the app probably isn't installed
        if (!hasRedirected && (Date.now() - navigatedAt < 1500)) {
          // App not opened, open the web URL in a new tab
          hasRedirected = true;
          window.open(webUrl, '_blank');
        }
      }, 1000);
      
      // Using visibility change to detect if app was launched
      document.addEventListener('visibilitychange', function handleVisibilityChange() {
        clearTimeout(timeoutId);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      }, { once: true });
      
      // Try to open the Spotify app
      // Using location.href would navigate away, so we use a hidden anchor instead
      const appLink = document.createElement('a');
      appLink.setAttribute('href', spotifyAppUri);
      appLink.style.display = 'none';
      document.body.appendChild(appLink);
      appLink.click();
      
      // Clean up the link element
      setTimeout(() => {
        if (document.body.contains(appLink)) {
          document.body.removeChild(appLink);
        }
      }, 100);
    } else {
      // On desktop, simply open in a new tab
      window.open(spotifyUrl, '_blank');
    }
  };
  
  return openSpotifyLink;
}
